import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const policyGptAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: `${AppConfig.POLICY_GPT_BASE_URL}/framework`,
});

setupInterceptors(policyGptAxiosInstance);

export default policyGptAxiosInstance;
